import React, { useState, useEffect } from 'react'
import Drawer from 'components/Drawer'
import TierDropdown from 'components/UIComponents/TierDropdown'
import Button from 'components/Button'
import { FlexWrap } from '../../CloseRolePopup/style'
import { Collapse } from 'antd'
const { Panel } = Collapse

const TierDrawer = ({
  open,
  editingRecord,
  onClose,
  initialTier,
  onUpdate,
  handleUpdate,
}) => {
  const [tier, setTier] = useState(initialTier || null)
  const [activePanel, setActivePanel] = useState(['1'])

  useEffect(() => {
    setTier(initialTier || null)
  }, [initialTier, open])

  const TIER_OPTIONS = [
    {
      label: 'Tier 1',
      value: 1,
      bg: '#FFE5ED',
      color: '#964D65',
      border: '1px solid #964D65',
    },
    {
      label: 'Tier 2',
      value: 2,
      bg: '#E7E0FF',
      color: '#7D64DA',
      border: '1px solid #7D64DA',
    },
    {
      label: 'Tier 3',
      value: 3,
      bg: '#E0F7FF',
      color: '#55A1BA',
      border: '1px solid #55A1BA',
    },
    {
      label: 'Tier 4',
      value: 4,
      bg: '#E0FFE5',
      color: '#58B981',
      border: '1px solid #58B981',
    },
  ]
  const content = () => {
    const [openAccordion, setOpenAccordion] = useState(true)
    return (
      <div style={{ margin: '32px 0' }}>
        <div
          style={{
            marginBottom: 12,
            background: '#fff',
            borderRadius: 10,
            border: '1px solid #DFDFDF',
            boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
            cursor: 'pointer',
            minHeight: 52,
            display: 'flex',
            alignItems: 'center',
            padding: '0 24px',
          }}
          onClick={() => setOpenAccordion(v => !v)}
        >
          <span
            style={{
              color: '#323538',
              fontFamily: 'Plus Jakarta Sans',
              fontWeight: 400,
              fontStyle: 'normal',
              fontSize: 15,
              lineHeight: '20px',
              letterSpacing: 0,
              height: 52,
              minHeight: 52,
              display: 'flex',
              alignItems: 'center',
              flex: 1,
            }}
          >
            Select Tier
          </span>
          <span
            style={{
              marginLeft: 12,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <svg
              width="8"
              height="5"
              viewBox="0 0 8 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.29635 4.3L0.69635 1.7C0.379683 1.38333 0.309017 1.021 0.48435 0.613C0.659017 0.204333 0.97135 0 1.42135 0H6.57135C7.02135 0 7.33368 0.204333 7.50835 0.613C7.68368 1.021 7.61302 1.38333 7.29635 1.7L4.69635 4.3C4.59635 4.4 4.48802 4.475 4.37135 4.525C4.25468 4.575 4.12968 4.6 3.99635 4.6C3.86302 4.6 3.73802 4.575 3.62135 4.525C3.50468 4.475 3.39635 4.4 3.29635 4.3Z"
                fill="#CCCFD6"
              />
            </svg>
          </span>
        </div>
        {openAccordion && (
          <div
            style={{
              background: '#fff',
              borderRadius: 10,
              border: '1px solid #DFDFDF',
              display: 'flex',
              gap: 16,
              padding: '22px 0',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 0,
            }}
          >
            {TIER_OPTIONS.map(option => (
              <button
                key={option.value}
                onClick={() => setTier(option.value)}
                style={{
                  minWidth: 74,
                  height: 29,
                  borderRadius: 14.5,
                  background: option.bg,
                  color: option.color,
                  border: option.border,
                  fontWeight: 600,
                  fontSize: 16,
                  outline: tier === option.value ? '2px solid #3249D7' : 'none',
                  boxShadow:
                    tier === option.value ? '0 0 0 2px #3249D7' : 'none',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                }}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
      </div>
    )
  }

  const footer = () => {
    return (
      <FlexWrap right>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
          <Button.Secondary text="Cancel" onClick={onClose} />
          <Button.Primary
            text="Update"
            onClick={() => handleUpdate(editingRecord, tier, true)}
          />
        </div>
      </FlexWrap>
    )
  }
  return (
    <Drawer
      zIndex={7000}
      onClose={onClose}
      width="40%"
      padding="0px 30px"
      title={'Edit Tier'}
      placement="right"
      closable={true}
      visible={true}
      content={content()}
      footer={footer()}
    />
  )
}

export default TierDrawer
